import { Stack, Typography, Drawer, Box } from "@mui/material";
import React, { useState } from "react";
import ImgBox from "../../../Components/ImgBox";
import HiddenContent from "./HiddenContent";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Navbar */}
      <Stack
        sx={{
          padding: "2rem",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
        direction="row"
      >
        <ImgBox
          onClick={() => navigate("/")}
          sx={{
            zIndex: "10000",
            width: { xs: "150px", lg: "250px" },
            cursor: "pointer",
          }}
          src="/media/global/viraTecGroup.svg"
        />

        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          onClick={() => setOpen(true)}
          sx={{
            cursor: "pointer",
            "&:hover .menu-line": { width: "45px", backgroundColor: "#00ffcc" },
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              letterSpacing: "3px",
              fontSize: "0.85rem",
              fontWeight: "600",
              color: "text.primary",
            }}
          >
            Menu
          </Typography>
          <Box
            className="menu-line"
            sx={{
              width: "25px",
              height: "2px",
              backgroundColor: "text.primary", // یا "#fff"
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          />
        </Stack>
      </Stack>

      {/* Drawer */}
      <Drawer
        anchor="top"
        open={open}
        onClose={() => setOpen(false)}
        transitionDuration={{
          enter: 600,
          exit: 450,
        }}
        SlideProps={{
          easing: {
            enter: "cubic-bezier(0.22, 1, 0.36, 1)",
            exit: "cubic-bezier(0.4, 0, 1, 1)",
          },
        }}
        PaperProps={{
          sx: {
            height: "100vh",
            backgroundImage: "url(/media/global/menu-back.svg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            color: "#fff",
            bgcolor: "background.default",
          },
        }}
      >
        <HiddenContent setOpen={setOpen} />
      </Drawer>
    </>
  );
}
